namespace GeniuzPOS.ReportMasterData {
    export interface Report_1502_NRow {
        Id?: string;
        Year?: string;
        SubCat1Code?: string;
        SubCat1Name?: string;
        TypeSum?: string;
        January?: number;
        February?: number;
        March?: number;
        April?: number;
        May?: number;
        June?: number;
        July?: number;
        August?: number;
        September?: number;
        October?: number;
        November?: number;
        December?: number;
    }

    export namespace Report_1502_NRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Id';
        export const localTextPrefix = 'ReportMasterData.Report_1502_N';
        export const deletePermission = '1POSBASE:รายงาน:เปรียบเทียบ:ยอดขายรายเดือน:View';
        export const insertPermission = '1POSBASE:รายงาน:เปรียบเทียบ:ยอดขายรายเดือน:View';
        export const readPermission = '1POSBASE:รายงาน:เปรียบเทียบ:ยอดขายรายเดือน:View';
        export const updatePermission = '1POSBASE:รายงาน:เปรียบเทียบ:ยอดขายรายเดือน:View';

        export declare const enum Fields {
            Id = "Id",
            Year = "Year",
            SubCat1Code = "SubCat1Code",
            SubCat1Name = "SubCat1Name",
            TypeSum = "TypeSum",
            January = "January",
            February = "February",
            March = "March",
            April = "April",
            May = "May",
            June = "June",
            July = "July",
            August = "August",
            September = "September",
            October = "October",
            November = "November",
            December = "December"
        }
    }
}
